// PDFCanvasViewer.js
import React, { useState, useRef, useEffect } from 'react';
import { pdfjs } from 'react-pdf';
import pdfFile from '../../../../icons/pdf/my.pdf';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const DemoFile = ({ fileUrl }) => {
  const [pdf, setPdf] = useState(null);
  const [pageNumber] = useState(1); // Adjust for different pages if needed
  const canvasRef = useRef(null);

  useEffect(() => {
    const loadPdf = async () => {
      const loadingTask = pdfjs.getDocument(pdfFile);
      const loadedPdf = await loadingTask.promise;
      setPdf(loadedPdf);
    };

    loadPdf();
  }, [pdfFile]);

  useEffect(() => {
    const drawPageOnCanvas = async () => {
      if (pdf) {
        const page = await pdf.getPage(pageNumber);
        const viewport = page.getViewport({ scale: 1.5 });
        const canvas = canvasRef.current;
        const context = canvas.getContext('2d');

        canvas.width = viewport.width;
        canvas.height = viewport.height;

        const renderContext = {
          canvasContext: context,
          viewport: viewport,
        };

        page.render(renderContext);
      }
    };

    drawPageOnCanvas();
  }, [pdf, pageNumber]);

  return (
    <div>
      <h2>PDF on Canvas</h2>
      <canvas ref={canvasRef} style={{ border: '1px solid black' }}></canvas>
    </div>
  );
};

export default DemoFile;
